import { Button, Stack, Typography } from '@sureco/design-system'
import { Modal, Select } from '@surecompanies/core_components'
import React from 'react'

export default function ContributionReportGenerateModal({
  open,
  onConfirm,
  onCancel,
  loading = false,
  year,
  yearOptions,
  onChangeYear,
}: {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  loading?: boolean
  year: number
  yearOptions: { value: number; label: string }[]
  onChangeYear: (year: number) => void
}) {
  return (
    <Modal
      open={open ?? false}
      onCancel={onCancel}
      footer={null}
      closable
      maskClosable
      width={600}
      zIndex={1002}
      centered
    >
      <Stack space={20}>
        <Stack space={0}>
          <Typography as="p" size={16} bold>
            Generate Contribution Report
          </Typography>
          <Typography as="p" size={14}>
            Are you sure you want to generate the contribution report for the
            following?
          </Typography>
          <table>
            <tbody>
              <tr>
                <td>Year</td>
                <td>
                  <Select
                    options={yearOptions}
                    value={year}
                    onChange={onChangeYear}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </Stack>

        <Stack direction="row" space={10} justify="end">
          <Button
            type="outline"
            variant="secondary"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="flat"
            variant="primary"
            onClick={onConfirm}
            loading={loading}
            disabled={loading}
          >
            Confirm
          </Button>
        </Stack>
      </Stack>
    </Modal>
  )
}
